/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * ProductReviewControllerApi - axios parameter creator
 */
export const ProductReviewControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} categoryCode
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet: (language_1, tenant_1, categoryCode_1, limit_1, ...args_1) => __awaiter(this, [language_1, tenant_1, categoryCode_1, limit_1, ...args_1], void 0, function* (language, tenant, categoryCode, limit, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet', 'tenant', tenant);
            // verify required parameter 'categoryCode' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet', 'categoryCode', categoryCode);
            const localVarPath = `/product-review/v1/{language}/{tenant}/category/{categoryCode}/reviews`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantProductsUpidGet: (language_1, tenant_1, upid_1, ...args_1) => __awaiter(this, [language_1, tenant_1, upid_1, ...args_1], void 0, function* (language, tenant, upid, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantProductsUpidGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantProductsUpidGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantProductsUpidGet', 'upid', upid);
            const localVarPath = `/product-review/v1/{language}/{tenant}/products/{upid}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Post a new product review for a variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {ReviewRequestV1} [ReviewRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantReviewsPost: (language_1, tenant_1, ReviewRequestV1_1, ...args_1) => __awaiter(this, [language_1, tenant_1, ReviewRequestV1_1, ...args_1], void 0, function* (language, tenant, ReviewRequestV1, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantReviewsPost', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantReviewsPost', 'tenant', tenant);
            const localVarPath = `/product-review/v1/{language}/{tenant}/reviews`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get rating stats for a certain variant for all languages (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet: (language_1, tenant_1, variant_code_1, ...args_1) => __awaiter(this, [language_1, tenant_1, variant_code_1, ...args_1], void 0, function* (language, tenant, variant_code, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet', 'tenant', tenant);
            // verify required parameter 'variant_code' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet', 'variant_code', variant_code);
            const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/all/summary`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all active reviews for a certain variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeReviewsGet: (language_1, tenant_1, variant_code_1, page_1, pageSize_1, ...args_1) => __awaiter(this, [language_1, tenant_1, variant_code_1, page_1, pageSize_1, ...args_1], void 0, function* (language, tenant, variant_code, page, pageSize, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeReviewsGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeReviewsGet', 'tenant', tenant);
            // verify required parameter 'variant_code' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeReviewsGet', 'variant_code', variant_code);
            const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/reviews`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get rating stats for a certain variant (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeSummaryGet: (language_1, tenant_1, variant_code_1, ...args_1) => __awaiter(this, [language_1, tenant_1, variant_code_1, ...args_1], void 0, function* (language, tenant, variant_code, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeSummaryGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeSummaryGet', 'tenant', tenant);
            // verify required parameter 'variant_code' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeSummaryGet', 'variant_code', variant_code);
            const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/summary`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductReviewControllerApi - functional programming interface
 */
export const ProductReviewControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductReviewControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} categoryCode
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProductReviewControllerApi.productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProductReviewControllerApi.productReviewV1LanguageTenantProductsUpidGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Post a new product review for a variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {ReviewRequestV1} [ReviewRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProductReviewControllerApi.productReviewV1LanguageTenantReviewsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get rating stats for a certain variant for all languages (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProductReviewControllerApi.productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all active reviews for a certain variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(language, tenant, variant_code, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(language, tenant, variant_code, page, pageSize, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProductReviewControllerApi.productReviewV1LanguageTenantVariantsVariantCodeReviewsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get rating stats for a certain variant (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProductReviewControllerApi.productReviewV1LanguageTenantVariantsVariantCodeSummaryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ProductReviewControllerApi - factory interface
 */
export const ProductReviewControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductReviewControllerApiFp(configuration);
    return {
        /**
         * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantCategoryCategoryCodeReviewsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.categoryCode, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantProductsUpidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantProductsUpidGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantProductsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
        /**
         * Post a new product review for a variant
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantReviewsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantReviewsPost(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantReviewsPost(requestParameters.language, requestParameters.tenant, requestParameters.ReviewRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Get rating stats for a certain variant for all languages (only active reviews)
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeAllSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all active reviews for a certain variant
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeReviewsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get rating stats for a certain variant (only active reviews)
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductReviewControllerApi - object-oriented interface
 */
export class ProductReviewControllerApi extends BaseAPI {
    /**
     * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantCategoryCategoryCodeReviewsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.categoryCode, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantProductsUpidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantProductsUpidGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantProductsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Post a new product review for a variant
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantReviewsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantReviewsPost(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantReviewsPost(requestParameters.language, requestParameters.tenant, requestParameters.ReviewRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get rating stats for a certain variant for all languages (only active reviews)
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeAllSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all active reviews for a certain variant
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeReviewsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get rating stats for a certain variant (only active reviews)
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(this.axios, this.basePath));
    }
}
